import { Variety } from '../../../../../../services/entities/impl/blfApi/schemas/variety';
import { StagesCountDataDisplay } from '../../../../../reports/blueberry/components/StagesCountDataDisplay';
import { useStagesCountDataset } from '../hooks/useStagesCountDataset';
import { StageCount } from '../types';

type Props = {
  stageCounts: StageCount[];
  stages: Variety['stages'];
};

export const BlockStageDataDisplay = ({ stageCounts, stages }: Props) => {
  const stagesCountDataset = useStagesCountDataset(stageCounts, stages);

  return <StagesCountDataDisplay dataset={stagesCountDataset} />;
};
